export const gtagEvent = (action, parmas) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, parmas);
  } else {
    console.warn('Google Analytics gtag function is not available.');
  }
};
